import { Component, OnDestroy, Input, AfterViewInit } from '@angular/core';
import { User, Whitelabel } from '@app/models';
import { ErrorHandlerService, UserService, WhitelabelService } from '@app/services';
import { filter, finalize } from 'rxjs/operators';
import { untilDestroyed } from '@app/core';
import { WhitelabelSendgridDns } from 'src/generated/graphql.default';
import { WhitelabelOpengraphModalService } from '@app/pages/configurations/configurations-whitelabel/whitelabel-opengraph-modal/whitelabel-opengraph-modal.service';

export enum contextMenuState {
  default = 0,
  domainName = 1,
  emailAddress = 2,
  signingPage = 3,
  signedDocument = 4
}

@Component({
  selector: 'app-configurations-whitelabel',
  templateUrl: './configurations-whitelabel.component.html',
  styleUrls: ['../configurations.scss', './configurations-whitelabel.component.scss'],
  standalone: false
})
export class ConfigurationsWhitelabelComponent implements AfterViewInit, OnDestroy {
  @Input() contextDefault = false;

  currentUser: User;
  contextMenuState = contextMenuState;
  contextMenu: contextMenuState = contextMenuState.default;

  whitelabelData: Whitelabel;
  sendgridDns: WhitelabelSendgridDns;

  isLoading = false;

  isDarkmode = false;

  constructor(
    public whitelabelService: WhitelabelService,
    private userService: UserService,
    private errorHandlerService: ErrorHandlerService,
    private whitelabelOpengraphModalService: WhitelabelOpengraphModalService
  ) {}

  ngAfterViewInit(): void {
    this.isLoading = true;
    this.userService
      .watchCurrentUser()
      .pipe(
        filter(user => !!user),
        untilDestroyed(this)
      )
      .subscribe({
        next: user => {
          this.currentUser = user;
        }
      });

    this.loadWhitelabel();
  }

  ngOnDestroy(): void {}

  loadWhitelabel() {
    this.whitelabelService.loadCurrentWhitelabel().subscribe({
      next: whitelabelData => {
        this.whitelabelData = whitelabelData;
        this.changeDarkMode();
        if (whitelabelData.sendgrid_domain) {
          this.loadSendGridDns();
        } else {
          this.isLoading = false;
        }
      }
    });
  }

  loadSendGridDns() {
    if (!this.whitelabelData || !this.whitelabelData.sendgrid_domain) {
      return;
    }
    this.whitelabelService.sendgridDns({ sendgrid_domain: this.whitelabelData.sendgrid_domain }).subscribe({
      next: sendgridDns => {
        this.sendgridDns = sendgridDns;
        this.isLoading = false;
      },
      error: error => {
        this.errorHandlerService.handle(error);
      }
    });
  }

  changeContext(context: contextMenuState) {
    this.contextMenu = context;
  }

  changeDarkMode() {
    if (this.whitelabelData.is_darkmode) {
      this.isDarkmode = true;
    } else this.isDarkmode = false;
  }

  goBack(context: contextMenuState) {
    this.sendgridDns = {};
    this.whitelabelService.loadCurrentWhitelabel().subscribe({
      next: whitelabelData => {
        this.whitelabelData = whitelabelData;
        this.changeDarkMode();
        this.contextMenu = context;
        this.loadSendGridDns();
      }
    });
  }

  openEditOpengraphModal() {
    this.whitelabelOpengraphModalService
      .open({ title: this.whitelabelData?.og_title, description: this.whitelabelData?.og_description, url: this.whitelabelData?.og_image })
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe({
        next: data => {
          this.whitelabelData = { ...this.whitelabelData, ...data };
        }
      });
  }
}
